/// <reference path="../../../../../typings/jquery.d.ts"/>
import { AppUtils } from '../../../../../../shared/utils/index';
import { User } from '../../../../../../shared/models/api/User/User';
import { ViewConfiguration } from '../../../../../../shared/services/BasicViewService';
import { BasicApplicationService } from '../../../../../../shared/services/BasicApplicationService';

import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { AppFormModel } from '../../models/AppFormModel';
import { AppApiService } from '../../services/AppApiService';
import { AppRouterService } from '../../services/AppRouterService';
import { BasicErrorService } from '../../../../../../shared/services/BasicErrorService';
import { InputPageController } from './InputPageController';
import { ApplicationPages } from '../../Constants';

export class OverviewPageController implements StepController {
	private readonly $ctx: JQuery;
	private readonly loader: BasicLoader<MyVehicleAppDefinition>;
	private readonly options: BasicAppOptions<MyVehicleAppDefinition>;
	private readonly applicationService: BasicApplicationService<MyVehicleAppDefinition>;
	private readonly applicationRouter: AppRouterService;
	private readonly appViewService: AppViewService;
	private readonly parent: AppController;
	private readonly user: User;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appApiService: AppApiService;
	private readonly basicErrorService: BasicErrorService<BasicAppDefinition>;

	constructor(parent: AppController, options: BasicAppOptions<MyVehicleAppDefinition>, loader: BasicLoader<MyVehicleAppDefinition>, user: User, formModel: AppFormModel) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.user = user;
		this.$ctx = options.$ctx;

		this.applicationService = new BasicApplicationService(options);
		this.applicationRouter = new AppRouterService(options);
		this.appPersistenceService = new AppPersistenceService(this.options);
		this.appViewService = new AppViewService(parent, this.options, this.loader);
		this.appApiService = new AppApiService(this, options);
		this.appPersistenceService.setFormModelToStore(formModel);
		this.basicErrorService = new BasicErrorService(options);
	}

	public start(): void {
		const viewConfig: ViewConfiguration<MyVehicleAppDefinition> = {
			data: this.getViewOptions(),
			templateurl: this.options.app.currenttemplate.templateurl,
			campaignurls: this.options.app.campaignurls,
			parent: this,
			$ctx: this.$ctx,
			options: this.options,
			callback: this.afterRenderApp
		};
		this.appViewService.render(viewConfig);
	}

	private getViewOptions(): { [key: string]: any } {
		const formModel = this.appPersistenceService.getFormModelFromStore();
		return {
			User: this.user,
			Fahrzeug: formModel && formModel.Fahrzeug && formModel.Fahrzeug.ID ? formModel.Fahrzeug : null
		};
	}

	public afterRenderApp(): void {
		const formModel = this.appPersistenceService.getFormModelFromStore();

		this.parent.afterRenderApp();
		this.appViewService.addOptionListeners(
			this.editVehicleListener.bind(this),
			this.deleteVehicleListener.bind(this),
			this.addVehicleListener.bind(this)
		);

		const urlParams = AppUtils.Url.getParamsAsSingle(window.location.search),
			vehicleID = urlParams.myVehicleId || urlParams.id;

		this.appViewService.updateAutokatalogImage(formModel);
		this.appViewService.updateAutokatalogUrls(vehicleID);

		AppUtils.View.stopLoader();
		AppUtils.View.scrollTop();
	}

	private editVehicleListener(e: JQuery.Event): void {
		e.preventDefault();

		const formModel = this.appPersistenceService.getFormModelFromStore();
		const inputOptions = this.applicationService.preparePageOptions(ApplicationPages.InputPage);
		let stepController;

		if (formModel.Fahrzeug.KfzId) {
			stepController = new InputPageController(this.parent, inputOptions, this.loader, this.user, true, formModel.Fahrzeug.KfzId);
		} else {
			stepController = new InputPageController(this.parent, inputOptions, this.loader, this.user, true);
		}

		stepController.start();
	}

	private addVehicleListener(e: JQuery.Event): void {
		e.preventDefault();
		this.appPersistenceService.clearApplicationSession();
		let url = window.location.href;
		if (window.location.search) {
			// remove vehicle ID from URL
			url = url.replace(new RegExp(`\\${window.location.search}$`), "");
		}
		this.applicationRouter.routeToLocation(url);
	}

	private deleteVehicleListener(e: JQuery.Event): void {
		e.preventDefault();
		const formModel = this.appPersistenceService.getFormModelFromStore();
		if (formModel.Fahrzeug && formModel.Fahrzeug.ID) {
			AppUtils.View.startLoader();
			this.appApiService.submitDeleteRequest(formModel.Fahrzeug.ID,
				(): void => {
					this.appPersistenceService.clearApplicationSession();
					AppUtils.View.stopLoader();
					this.applicationRouter.success();
				}, this.handleErrorResponse.bind(this));
		}
	}

	private handleErrorResponse(jqxhr: JQueryXHR): void {
		AppUtils.View.stopLoader();
		if (!this.basicErrorService.handleBadRequestErrorWithDialog(jqxhr, `${this.options.name} API error`)) {
			this.basicErrorService.handleAllOtherHttpErrors(`${this.options.name} API error`);
		} else {
			if (this.basicErrorService.isQualifiedError(jqxhr)) {
				this.appPersistenceService.clearApplicationSession();
				this.basicErrorService.handleTechnicalError(jqxhr);
			} else {
				this.basicErrorService.hideErrorDialog();
			}
		}
	}
}
